// extracted by mini-css-extract-plugin
export var divider = "_1h-0";
export var dividerText = "_1h-2";
export var dividerVertical = "_1h-1";